






































import {Component, Prop, Watch, Vue} from 'vue-property-decorator';
import Draggable from 'vuedraggable';
import {cloneDeep} from 'lodash';

@Component({
    components: {
        Draggable,
    },
})
export default class FlexGridSettingsEditDialogGroups extends Vue {
    @Prop() value!: any;

    private items: any = null;

    @Watch('value', {immediate: true, deep: true})
    onValueChange(value: any) {
        this.items = cloneDeep(value);
    }

    onInput(value: any) {
        this.$emit('input', value);
    }
}
